module.exports = __webpack_public_path__ + "media/images/bg_counseling-ac9599d233b499739b4b3144dda1e61b.webp";